module.exports = __webpack_public_path__ + "static/media/cervical-ripening-balloon-steps-of-use-poster@3x.a17132f7.jpg";